import { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { About } from "./components/about";
import { Gallery } from "./components/gallery";
import { Testimonials } from "./components/testimonials";
import { CursosNew } from "./components/CursosNew";
import { Cursos } from "./components/Cursos";
import { Cursos2 } from "./components/Cursos2";
import { Contact } from "./components/contact";
import { BellasTardes } from "./components/BellasTardes";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import { logPageView } from './analytics'
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    logPageView();
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <Navigation />
      <Header data={landingPageData.Header} />
      <About data={landingPageData.About} />  
      <BellasTardes />
      <CursosNew data={landingPageData.TeamNew}/>
      <Cursos data={landingPageData.Team}/>
      <Cursos2 data={landingPageData.Team2} />
      <Gallery data={landingPageData.Gallery}/>
      <Testimonials data={landingPageData.Testimonials} />
      <Contact data={landingPageData.Contact} />
    </div>
  );
};

export default App;
